export default __webpack_public_path__ + "static/media/varo-money-p1.6c3c7897.png";